/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import {
  Avatar,
  Box, Card, CardContent,
  makeStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import bt_medal from '../../../assets/img/medalSelectedMentor.png';

const useStyles = makeStyles((theme) => ({
  side: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    fontWeight: 500,
    color: theme.palette.background.info,
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontSize: '20px',
    fontWeight: 500,
    color: theme.palette.text.default,
    margin: theme.spacing(3, 0, 1, 0),
  },
  mentorCardTextSubtitle: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.text.default,
    textAlign: 'center',
  },
  mentorCardTextImg: {
    width: 60,
    height: 60,
    borderRadius: '50%',
  },
  mentorCardTextIcon: {
    width: '24px',
    height: '35px',
  },
  mentorSelectedCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: theme.palette.background.card,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.background.info}`,
    minHeight: 250,
  },
  mentorSelectedCardHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mentorSelectedCardImgSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  mentorSelectedCardHeaderTitle: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    fontWeight: 500,
    color: theme.palette.text.default,
  },
  mentorSelectedCardSkillsTitle: {
    fontFamily: 'Raleway',
    fontSize: '16px',
    fontWeight: 400,
    color: theme.palette.text.default,
    margin: theme.spacing(1, 0),
  },
  mentorSelectedCardSkillsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  mentorSelectedCardSkillPointBlue: {
    background: theme.palette.background.primary,
    borderRadius: '50%',
    width: 10,
    height: 10,
  },
  mentorSelectedCardSkillPointYellow: {
    background: theme.palette.background.info,
    borderRadius: '50%',
    width: 10,
    height: 10,
  },
  mentorSelectedCardSkillPointPink: {
    background: theme.palette.background.secondary,
    borderRadius: '50%',
    width: 10,
    height: 10,
  },
  mentorSelectedCardSkillPointText: {
    textTransform: 'capitalize',
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: 14,
    marginLeft: theme.spacing(1),
  },
  mentorSelectedCardSkillPointContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export function SelectedMentor({ mentor }) {
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.side}>
        <Typography className={classes.subtitle}>
          Mentor seleccionado
        </Typography>
        <Card className={classes.mentorSelectedCard}>
          <CardContent>
            <Box className={classes.mentorSelectedCardHeader}>
              <Box className={classes.mentorSelectedCardImgSection}>
                <Avatar
                  src={mentor.photo}
                  className={classes.mentorCardTextImg}
                  alt="mentor"
                />
                <img
                  src={bt_medal}
                  className={classes.mentorCardTextIcon}
                  alt="insignia"
                />
              </Box>
              <Typography className={classes.mentorSelectedCardHeaderTitle}>
                {mentor.fullName}
              </Typography>
              <Typography className={classes.mentorCardTextSubtitle}>
                {mentor.specialty}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.mentorSelectedCardSkillsTitle}>
                Habilidades
              </Typography>
              <Box className={classes.mentorSelectedCardSkillsContainer}>
                {mentor.skills.map((item, index) => {
                  if (index === 0) {
                    return (
                      <Box
                        className={classes.mentorSelectedCardSkillPointContainer}
                        key={item.mentor}
                      >
                        <Box className={classes.mentorSelectedCardSkillPointBlue} />
                        <Typography
                          className={classes.mentorSelectedCardSkillPointText}
                        >
                          {item}

                        </Typography>
                      </Box>
                    );
                  }
                  if (index === 1) {
                    return (
                      <Box className={classes.mentorSelectedCardSkillPointContainer}>
                        <Box className={classes.mentorSelectedCardSkillPointYellow} />
                        <Typography
                          className={classes.mentorSelectedCardSkillPointText}
                        >
                          {item}

                        </Typography>
                      </Box>
                    );
                  }
                  return (
                    <Box className={classes.mentorSelectedCardSkillPointContainer}>
                      <Box className={classes.mentorSelectedCardSkillPointPink} />
                      <Typography
                        className={classes.mentorSelectedCardSkillPointText}
                      >
                        {item}

                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </CardContent>
        </Card>
        <Typography className={classes.subtitle}>Más mentores</Typography>
      </Box>
    </Box>
  );
}

SelectedMentor.propTypes = {
  mentor: PropTypes.objectOf(PropTypes.string).isRequired,
};
